module.exports = __webpack_public_path__ + "img/career-main.786300dc.jpg";